module.exports = __webpack_public_path__ + "static/img/100104.068488bf.png";